import React, { useState } from 'react'
import _, { isEmpty ,isNull } from 'lodash'
import { Button, Col, Form, Icon, Input, Modal, Radio, Row, Upload } from 'antd'
import { ButtonEx } from '../../../../styles/button.style'
import { useDeepEffect } from '../../../../utils/hooks'
import axios from 'axios'
import { beforeUpload, compressFile, getBase64 } from '../../../../utils/services'

const SellerForm = (props) => {
  const { visible, onOk, onCancel, formData, form } = props
  const { getFieldDecorator, validateFields, setFieldsValue } = form
  const [imageUrl, setImageUrl] = useState("")

  useDeepEffect(() => {
    if (!isEmpty(formData)) {
      setFieldsValue({
        name: formData.name,
        detail: formData.detail,
        email:formData.email,
        tel:formData.tel,
        lineId:formData.lineId
      })
      setImageUrl(formData.logo)
    }

    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formData])

  const uploadButton = (
    <div>
      <Icon type="plus" />
      <div className="ant-upload-text">Upload</div>
    </div>
  )

  async function handleChange(info) {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  function onSubmit(e) {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        const data = {
          name: values.name,
          detail: values.detail,
          email:values.email,
          tel:values.tel,
          lineId:values.lineId
        }
        if (values.image) {
          try {
            const formImgData = new FormData()
            if (!_.isNull(values.image.file)) {
              formImgData.append('image', await compressFile(values.image.file))
              const res = await axios.post(
                process.env.REACT_APP_API_ENDPOINT + `/equipment/image`,
                formImgData,
                {
                  headers: {
                    'content-type': 'multipart/form-data'
                  }
                }
              )
              data.logo = res.data.url
            }
          } catch (err) {
            console.log(err)
          }
        }else{
          data.logo = formData.logo
        }
        if (!_.isEmpty(formData)) {
          data.id = formData.id
        }
        onOk(data)
      }
    })
  }
  return (
    <Modal
    title={`${!_.isEmpty(formData) ? 'Edit' : 'Create'} a Seller`}
      visible={visible}
      footer={null}
      onCancel={onCancel}>
      <Form form={form} onSubmit={onSubmit} layout="vertical">
      <Form.Item label="รูปหน้าปก">
          <Row type="flex" justify="center">
            <Col>
              {getFieldDecorator(`image`, {
                rules: [
                  {
                    required: isNull(formData),
                    message: 'เลือกรูปภาพ'
                  }
                ]
              })(
                <Upload
                  name="img"
                  listType="picture-card"
                  showUploadList={false}
                  beforeUpload={(file) => beforeUpload(file)}
                  onChange={handleChange}
                >
                  {imageUrl ? (
                    <img src={imageUrl} alt="img" style={{ width: '100%' }} />
                  ) : (
                    uploadButton
                  )}
                </Upload>
              )}
            </Col>
          </Row>
        </Form.Item>
        <Form.Item label="Name">
          {getFieldDecorator(`name`, {
          })(<Input
            name="name"
            placeholder="ชื่อ" />)}
        </Form.Item>
        <Form.Item label="Detail">
          {getFieldDecorator(`detail`, {
          })(<Input.TextArea
            name="detail"
            placeholder="รายละเอียด" />)}
        </Form.Item>
        <Form.Item label="Email">
          {getFieldDecorator(`email`, {
          })(<Input
            name="email"
            placeholder="อีเมล" />)}
        </Form.Item>
        <Form.Item label="เบอร์โทร">
          {getFieldDecorator(`tel`, {
          })(<Input
            name="tel"
            placeholder="เบอร์โทร" />)}
        </Form.Item>
        <Form.Item label="Line Id">
          {getFieldDecorator(`lineId`, {
          })(<Input
            name="lineId"
            placeholder="Line Id" />)}
        </Form.Item>
        <Row type="flex" gutter={8} justify="end">
          <Col>
            <Button onClick={() => onCancel()}>ยกเลิก</Button>
          </Col>
          <Col>
            <ButtonEx color="#6ebf4b" type="primary" htmlType="submit">
               Save
            </ButtonEx>
          </Col>
        </Row>
      </Form>
    </Modal>
  )
}

const WrappedSellerForm = Form.create({ name: 'SellerForm' })(
  SellerForm
)
export default WrappedSellerForm